import React, { useState } from "react";
import Button from "../Shared/Button";

const ActingPatientForm = ({ handleSubmit, isSubmitting, handleSubmitSnap }) => {
  const [answerYes, setAnswerYes] = useState(null);
  const [submittedYes, setSubmittedYes] = useState(null);

  return (
    <>
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <div className="content">You are able to answer Yes or No to appointment for this patient.</div>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <div className="buttons has-addons">
              <button
                className={`button is-small is-radiusless ${answerYes === true ? "is-primary is-selected" : ""}`}
                onClick={() => setAnswerYes(true)}
              >
                Yes
              </button>
              <button
                className={`button is-small is-radiusless ${answerYes === false ? "is-primary is-selected" : ""}`}
                onClick={() => setAnswerYes(false)}
              >
                No
              </button>
            </div>
          </div>
          <div className="level-item">
            <Button
              text="Submit"
              isFullWidth={false}
              isLoading={isSubmitting}
              disabled={answerYes === null}
              onClick={() => handleSubmit(answerYes)}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <div className="content">Patient had submitted snapform.</div>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <div className="buttons has-addons">
              <button
                className={`button is-small is-radiusless ${submittedYes === true ? "is-primary is-selected" : ""}`}
                onClick={() => setSubmittedYes(true)}
              >
                Yes
              </button>
              <button
                className={`button is-small is-radiusless ${submittedYes === false ? "is-primary is-selected" : ""}`}
                onClick={() => setSubmittedYes(false)}
              >
                No
              </button>
            </div>
          </div>
          <div className="level-item">
            <Button
              text="Submit"
              isFullWidth={false}
              isLoading={isSubmitting}
              disabled={submittedYes === null}
              onClick={() => handleSubmitSnap(submittedYes)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ActingPatientForm;
